'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.threadFromProps = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var threadFromProps = exports.threadFromProps = function threadFromProps(state) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _get2.default)('thread', props);
};


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/threadFromProps.js
// module id = 77
// module chunks = 2 3